import _ from "lodash";
import {reloadGridDetailContent} from "../../grid/detail";
import {jqGet} from "../helpers";

export function openInModalDialog(href, windowWidth, id) {
	if (typeof id === 'undefined') {
		id = 'default-modal';
	}

	showLoadingProgress();

	var existingWindow = $('#' + id)
	if (existingWindow.length) {
		var myWindow = existingWindow;
	} else {
		var myWindow = $('<div id="' + id + '"> </div>').appendTo("body");
	}

	if (typeof windowWidth == 'undefined') {
		windowWidth = '800px'
	}

	jqGet(href, function (htmlData) {
		var $modalCont = $(htmlData);

		myWindow.kendoWindow({
			width: windowWidth,
			visible: true,
			modal: true,
			close: function(e) {

				let imgGallery = $('#blueimp-gallery img').length;
				if (imgGallery > 0) {
					e.preventDefault();
					return;
				}

				if ($modalCont.find('modal-body').data('after') === 'reload-detail' && window.runDialogAfterCallback) {
					reloadGridDetailContent();
				}
				if ($modalCont.find('modal-body').data('after') === 'reload-grid' && window.runDialogAfterCallback) {
          fetchNewDataFromUrl(gridDataUrl);
				}

        window.runDialogAfterCallback = false;
        window.loaderEnabled = true;

				kendo.destroy(myWindow);
			}
		});

		hideLoadingProgress();

		myWindow.closest('.k-window').find('.k-window-title').html($modalCont.find('modal-title').html());
		myWindow.closest('.k-window').find('.k-window-content').html($modalCont.find('modal-body').html());

		handleComponents(myWindow.closest('.k-window').find('.k-window-content'));

		var popup = myWindow.data('kendoWindow');
		popup.open().toFront().center().setOptions({
			position: {
				top: window.modalTop === undefined ? 150 : window.modalTop,
			}
		});

		if (windowWidth === 'fullscreen') {
			popup.maximize();
		}

		_.forEach(defaultModalContentLoaderCallback, function(callback) {
			if (typeof callback === 'function') {
				callback()
			}
		})

		window.scrollTo(0, 0)
		window.openedPopup = popup;
	});

}

window.openInModalDialog = openInModalDialog

export function showModalDetail(params) {
	if (params.colDef.editable === false) {
		openInModalDialog(detailLink.replace('9999999', params.data.id), '1000px');
	}
}
